import { toString } from "../util/toString.mjs";
//#region src/compat/string/split.ts
function split(string, separator, limit) {
	return toString(string).split(separator, limit);
}
//#endregion
export { split };
